"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'dayDeposit',
  components: {
    drawer: _filter.default
  },
  data: function data() {
    var _this = this;
    return {
      form: {},
      list: {},
      listQuery: {
        depend_type: '-1'
      },
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 86400;
          }
        }
      }
    };
  },
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    },
    deviceNameObj: function deviceNameObj() {
      return this.$store.getters.deviceNameObj;
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (type == 1) this.form = {};
      this.listQuery.start = 1;
      this.getList();
    },
    showLoad: function showLoad() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '数据获取中……';
      this.loadObj = this.$loading({
        lock: true,
        text: text,
        spinner: 'el-icon-loading'
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.showLoad('数据获取中……');
      var url = 'agentapi/statistics/my_deposit_date_data';
      var listQuery = Object.assign(this.form, this.listQuery, {});
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      this.$get(url, listQuery).then(function (res) {
        _this2.loadObj.close();
        _this2.list = res;
      }).catch(function () {});
    }
  }
};